import { FC, useEffect, useState } from 'react';
import Constants from '../../constants/constants';
import DomainUrlRedirect from './domainUrlRedirect';
import Gamification from '../services/Gamification';

const MarbleRedirect: FC = () => {
  // TODO: Set up typing for redux store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [redirectOn, setRedirectOn] = useState(false);

  useEffect(() => {
    Gamification.emitEvent({ action: 'access_academy', new_event: {} })
      .then(() => setRedirectOn(true))
      .catch((error) => console.error(error));
  }, []);

  if (redirectOn) {
    return <DomainUrlRedirect url={Constants.SSO_REDIRECT_URLS['marble']} searchParams={''} pathname={''} />;
  }

  return <></>;
};

export default MarbleRedirect;
